import { cx } from '@emotion/css';

import PersonalIdentityDialog from 'components/dialogs/PersonalIdentityDialog';
import PageRow from 'components/PageRow';
import ArrowLeft from '@new-components/shapes/ArrowLeft';

import progressImage1 from 'assets/1of3.png';
import progressImage2 from 'assets/2of3.png';
import progressImage3 from 'assets/3of3.png';

// import services from 'services';
import useGlobalState from 'actions';
import { StepProps } from './types';
import { stepCx } from './styles';

const Step = ({
  step = 0,
  padding = 0,
  size,
  className,
  onGoBack,
}: StepProps) => {
  const [state, actions] = useGlobalState();

  let progressImage: string | null = progressImage1;
  let pageHead = 'Identitas Diri';
  let pageSubtitle: string | null = null;
  if (step === 1) {
    progressImage = progressImage2;
    pageHead = 'Informasi Keluarga';
    pageSubtitle = 'Selanjutnya: Informasi Keuangan';
  } else if (step === 2) {
    progressImage = progressImage3;
    pageHead = 'Informasi Keuangan';
    pageSubtitle = 'Selanjutnya: Preview';
  } else if (step === 3) {
    progressImage = null;
    pageHead = 'Review';
    pageSubtitle = 'Kamu ga perlu isi, cek data lagi sebelum submit ya!';
  }

  const goBack = () => {
    onGoBack(step);

    if (step === 0) {
      actions.openPersonalIdentityDialog('preOpen', true);
    }
  };

  return (
    <PageRow
      className={cx(
        stepCx(step),
        'step',
        { 'with-progress': !!progressImage },
        className,
      )}
      padding={padding}
      size={size}
    >
      <div className='back-btn'>
        <ArrowLeft fill={step === 3 ? 'white' : '#616161'} onClick={goBack} />
      </div>
      {progressImage && (
        <div className='progress'>
          <img src={progressImage} alt='progress' />
        </div>
      )}
      <div className='step-title'>
        <h3>{pageHead}</h3>
        <span>{pageSubtitle}</span>
      </div>
      <PersonalIdentityDialog preOpen={state.preOpen} />
    </PageRow>
  );
};

export default Step;
